import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import styleConstants from "../../styleConstants";

const useStyles = makeStyles({
  containerLarge: {
    backgroundColor: styleConstants.colors.themeBlueLight,
    borderTop: `2px solid ${styleConstants.colors.themeBlue}`
  },
  containerSmall: {
    backgroundColor: styleConstants.colors.themeBlueLight,
    borderTop: `2px solid ${styleConstants.colors.themeBlue}`,
    width: "50%"
  },
  content: {
    padding: "1rem 2rem 2rem"
  },
  reference: {
    display: "inline-block",
    backgroundColor: styleConstants.colors.themeBlue,
    padding: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: styleConstants.fontWeights.bold,
    textTransform: "uppercase",
    color: "white"
  }
});

const TextBox = props => {
  const classes = useStyles(props);

  return (
    <div
      className={props.large ? classes.containerLarge : classes.containerSmall}>
      <div className={classes.reference}>{props.reference}</div>
      <div className={classes.content}>
        {props.subTitle ? (
          <>
            <h4 className="figure-title">{props.title}</h4>
            <h4 className="figure-subtitle">{props.subTitle}</h4>
          </>
        ) : (
          <h4 className="figure-title-only">{props.title}</h4>
        )}
        {props.children}
      </div>
    </div>
  );
};

TextBox.propTypes = {
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  large: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

TextBox.defaultProps = {
  large: false
};

export default TextBox;
